<template>
  <div>
    <div class="d-flex search-field-box align-start">
      <div :class="['field-group full-width', {active:highlight.active==='pickup'}]">
        <airport-location-input :value="pickup" :extra="pickupExtra" ref="pickup"
          :disabled="buttonLoading" :error="validation.pickup" leg="leg1"
          @change="locationNewValue" @submit="triggerClickSubmit"
          @nextFocus="nextHighlight" @clickFocus="highlight.active = 'pickup'"
        ></airport-location-input>
      </div>

      <div class="reverse-loc-box">
        <i class="fas fa-exchange-alt reverse-loc" @click="reverseLoc"></i>
      </div>

      <div :class="['field-group full-width', {active:highlight.active==='dropoff'}]">
        <airport-location-input :value="dropoff" :extra="dropoffExtra" ref="dropoff"
          :disabled="buttonLoading" :error="validation.dropoff" leg="leg1"
          @change="locationNewValue" @submit="triggerClickSubmit" 
          @nextFocus="nextHighlight" @clickFocus="highlight.active = 'dropoff'"
        ></airport-location-input>
      </div>

      <div :class="['field-group', {'field-error':!!d2dValidation.date, active:highlight.active==='date'}]">
        <input type="text" @click="openDeparturePicker" :disabled="buttonLoading"
          :class="['field-text', {disabled:buttonLoading}]" placeholder="Select Date"
          v-model="departureDate" ref="departure" readonly />
        <span class="field-error-message">{{ d2dValidation.date }}</span>
      </div>

      <div :class="['field-group', {active:highlight.active==='pax'}]">
        <input type="text" @click="openTravellersModal" :disabled="buttonLoading"
          :class="['field-text', {disabled:buttonLoading}]" placeholder="Select Date"
          :value="`${filters.travellers.total} Traveler(s)`" ref="departure" readonly />
      </div>

      <a href="#/d2dservice" @click="submit($event)" ref="quoteBtn"
        :class="['op-btn btn-md btn-black search-submit', {'disabled':buttonLoading, active:highlight.active==='search' & !buttonLoading}]"
      >
        <span v-if="!buttonLoading">Search</span>
        <span v-else><i class="fa fa-spinner fa-spin"></i> Searching</span>
      </a>
    </div>

    <travellers-modal></travellers-modal>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import AirportLocationInput from '../AirportLocationInput'
import TravellersModal from '../TravellersModal'
import trackError from '@/modules/api/track-error'
import booking from '@/modules/api/booking'

export default {
  name: 'flight-form',
  components: { AirportLocationInput, TravellersModal },
  data () {
    return {
      pickup: '',
      dropoff: '',
      pickupText: '',
      dropoffText: '',
      timezoneLoading: false,
      validation: {
        pickup: '',
        dropoff: ''
      },
      quoteErrorMsg: '',
      d2dQueue: [],
      d2dValidation: {
        date: ''
      },
      lastPickup: '',
      lastDropoff: '',
      showOnLoad: false,
      highlight: {
        active: 'pickup',
        delay: ''
      },
      flightQuoteError: {
        leg1: 0,
        leg2: 0
      }
    }
  },
  computed: {
    user () { return this.$store.state.user },
    booking () { return this.$store.state.booking },
    airlines () { return this.booking.airlines },
    filters () { return this.booking.filters },
    locations () { return this.booking.locations },
    isReturning () { return this.filters.departure.isReturning },
    _pickup () { return this.locations.flight.pickup.title },
    _dropoff () { return this.locations.flight.dropoff.title },
    rsvpData () { return this.$store.state.reservation },
    airlineLoading () { return this.rsvpData.airlineLoading },

    pickupExtra () {
      return {
        field: 'pickup',
        placeholder: 'Leaving from'
      }
    },
    dropoffExtra () {
      return {
        field: 'dropoff',
        placeholder: 'Going to',
        error: this.validation.dropoff
      }
    },
    buttonLoading () { return this.timezoneLoading || this.airlineLoading },
    d2dEnabled () { return CONFIG.featureToggle.d2dBooking },
    departureDate () {
      let date1 = moment(this.filters.departure.date, 'MM/DD/YYYY').format('MMM DD')
      if (this.filters.departure.isReturning) {
        let date2 = moment(this.filters.departure.return, 'MM/DD/YYYY').format('MMM DD')
        return `${date1} - ${date2}`
      }
      return date1
    },
    _brandId () { return this.$store.state.brandId },
    other () { return this.$store.state.other },
    currencyStore () { return this.other.currency }
  },
  methods: {
    locationNewValue (value) {
      let self = this
      if (!value.keyInput.trim()) return

      if (value.field === 'pickup') {
        self.pickupText = value.keyInput
        this.$emit('pickupChange')
        if (value.keyInput.trim() === '') {
          self.$store.commit('booking/setLocationsData', {pickup: ''})
        } else {
          if (!value.blurStop) {
            this.validation.pickup = ''
            this.$refs.dropoff.focus()
          }
        }
      } else {
        self.dropoffText = value.keyInput
        if (value.keyInput.trim() === '') {
          self.$store.commit('booking/setLocationsData', {dropoff: ''})
        } else {
          this.validation.dropoff = ''
        }
      }
      if (value.val) {
        let tmp = {}
        tmp[value.field] = value.val
        self.$store.commit('booking/setFlightLocationsData', tmp)
      }
    },
    triggerClickSubmit () {
      if (this.$refs.quoteBtn) this.$refs.quoteBtn.click()
    },
    reverseLoc () {
      let pickup = Object.assign({}, this.locations.flight.pickup)
      let dropoff = Object.assign({}, this.locations.flight.dropoff)

      this.dropoffText = pickup.title
      this.pickupText = dropoff.title
      this.dropoff = pickup.title
      this.pickup = dropoff.title
      this.$store.commit('booking/setLocationsData', {
        pickup: dropoff,
        dropoff: pickup
      })
      this.$emit('pickupChange')
    },
    openDeparturePicker () {
      this.$store.commit('booking/setDepartureData', {show: true})
    },
    openTravellersModal () {
      this.$store.commit('booking/setTravellersData', {show: true})
    },
    submit (event = null) {
      if (event) event.preventDefault()
      // validator
      let self = this

      self.validation.pickup = ''
      self.validation.dropoff = ''
      let hasError = false
      if (self.pickupText.trim() === '') {
        hasError = true
        self.validation.pickup = self.$t('common.fieldEmpty')
      } else if ((typeof self.locations.flight.pickup === 'object' && !Object.keys(self.locations.flight.pickup).length) || !self.locations.flight.pickup) {
        hasError = true
        self.validation.pickup = 'Please select location'
      }
      if (self.dropoffText.trim() === '') {
        hasError = true
        self.validation.dropoff = self.$t('common.fieldEmpty')
      } else if ((typeof self.locations.flight.dropoff === 'object' && !Object.keys(self.locations.flight.dropoff).length) || !self.locations.flight.dropoff) {
        hasError = true
        self.validation.dropoff = 'Please select location'
      }
      if (!self.filters.departure.date) {
        hasError = true
        self.d2dValidation.date = self.$t('common.fieldEmpty')
      }

      if (!!self.validation.pickup && this.highlight.active === 'pickup') this.highlight.active = ''
      if (!!self.validation.dropoff && this.highlight.active === 'dropoff') this.highlight.active = ''

      if (hasError) {
        return
      }

      if (window.gtag) { // eslint-disable-line
        gtag('event', 'Flight Booking - Search') // eslint-disable-line
      }

      self.$store.commit('other/setOtherData', {
        appLoader: true,
        appLoaderMsg: ''
      })

      self.d2dQueue = []
      if (!localStorage.getItem('firstVisitData') && !self.user.token && self.booking.settings.requirePhone) self.d2dQueue.push('getMobile')
      else self.d2dQueue.push('getFlight')
      self.d2dProcess()
    },
    d2dProcess () {
      let self = this
      if (!self.d2dQueue.length) return
      if (self.d2dQueue[0] === 'getFlight') {
        // self.$store.commit('other/setOtherData', {appLoaderMsg: 'Searching Flights...'})
        self.$store.commit('other/setOtherData', {
          appLoaderMsg: 'Don’t close now—your perfect deal is loading! This only takes up to a minute.',
          useLoadingMsg: true
        })
        // self.getFlightQuote()
        let leg1 = [...self.booking.cabinList]
        let tmp = {loading: [], selectedCabin: 'Economy'}
        self.$store.commit('booking/setAirlinesLegData', {leg: 'leg1', fields: tmp})
        leg1.forEach(cabin => {
          self.getFlightQuote(cabin, 'leg1')
          if (self.isReturning) self.getFlightQuote(cabin, 'leg2')
        })
      }
      if (self.d2dQueue[0] === 'getMobile') {
        self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        self.$store.commit('user/setFirstVisitData', {
          show: true,
          source: 'flight'
        })
      }
    },
    getFlightQuote (cabin, leg) {
      let self = this
      if (self.booking.airlines[leg].loading.indexOf(cabin) > -1) return
      self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: cabin})

      // Reset Airlines Data - By Cabin
      booking.resetAirlineData(self, cabin, leg)

      let params = booking.flightParam(self, cabin, leg)
      self.$sdk.post2(`${CONFIG.d2dAPI}/flight`, params, r => {
        try {
          if (r === null || !Object.keys(r).length || r.code === 'ETIMEDOUT' || r.error === 'No flight data found in the response.') {
            self.flightQuoteError[leg] = 3
            // self.$store.commit('global/setAlertData', {show: true, message: `No flights found. Please try again later.`})
            trackError.track(self, {
              type: 'flight_booking',
              data: {
                main_pickup: self.locations.flight.pickup,
                main_dropoff: self.locations.flight.dropoff,
                request: {
                  url: `${CONFIG.d2dAPI}/flight`,
                  payload: params
                },
                response: r
              }
            })
            self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: cabin})
            self.flightQuoteDone(cabin, leg)
            return
          }

          if (r.code === 'ERR_BAD_RESPONSE') {
            if (self.flightQuoteError[leg] < 2) self.flightQuoteError[leg] = 2
            // self.$store.commit('global/setAlertData', {show: true, message: `Oops! Something went wrong. Please try again later. `})
            trackError.track(self, {
              type: 'flight_booking',
              data: {
                main_pickup: self.locations.flight.pickup,
                main_dropoff: self.locations.flight.dropoff,
                request: {
                  url: `${CONFIG.d2dAPI}/flight`,
                  payload: params
                },
                response: r
              }
            })
            self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: cabin})
            self.flightQuoteDone(cabin, leg)
            return
          }

          let tmpStoredData = {leg: leg, fields: {}}
          tmpStoredData.fields[cabin] = r
          self.$store.commit('global/setStoredFlightData', tmpStoredData)

          if (r.FlightDataList && r.FlightDataList.JourneyList && r.FlightDataList.JourneyList[0]) {
            let flightData = booking.buildFlightData(self, r, cabin, leg)

            // Save Flight List
            let tmpAirlineLegData = {leg: leg, fields: {}}
            tmpAirlineLegData.fields[cabin] = flightData.flights
            self.$store.commit('booking/setAirlinesLegData', tmpAirlineLegData)

            // Save Airline Unique
            let tmpAirlineUnique = {}
            tmpAirlineUnique[cabin] = flightData.airlinesUnique
            self.$store.commit('booking/setAirlinesUniqueLegData', {
              leg: leg,
              fields: tmpAirlineUnique
            })

            if (self.lastPickup !== self._pickup || self.lastDropoff !== self._dropoff) {
              // Setup: Opt-in Ground Booking
              self.$store.commit('booking/setOthersData', {includedLandTranspo: []})
            }

            let tmpApplyFilter = {leg: leg, fields: {}}
            tmpApplyFilter.fields[cabin] = true
            self.$store.commit('booking/setApplyFilter', tmpApplyFilter)

            self.setupPax()
            self.$store.commit('reservation/setOtherData', {bookingType: 'flight'})
            self.$store.commit('booking/setOthersData', {activeLeg: 'leg1'})
            self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: cabin})
            self.flightQuoteDone(cabin, leg)
          }
        } catch (error) {
          if (self.flightQuoteError[leg] < 1) self.flightQuoteError[leg] = 1
          // self.$store.commit('global/setAlertData', {show: true, message: 'Something went wrong. Please adjust your search and try again.'})
          trackError.track(self, {
            type: 'flight_booking',
            data: {
              main_pickup: self.locations.flight.pickup,
              main_dropoff: self.locations.flight.dropoff,
              request: {
                url: `${CONFIG.d2dAPI}/flight`,
                payload: params
              },
              response: '',
              console_error: error
            }
          })
          self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: cabin})
          self.flightQuoteDone(cabin, leg)
        }
      })
    },
    setupPax () {
      let paxForm = { adult: [], children: [], infants: [] }
      let paxFields = {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        suffix: '',
        mobile: '',
        email: '',
        bday: '',
        birthDay: '',
        birthMonth: '',
        birthYear: '',
        passport: '',
        address: '',
        city: '',
        zip: '',
        country: '',
        countryCode: ''
      }
      let defaultAdded = false
      for (let x = 0; x < this.filters.travellers.adult; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        if (this.user.token && x === 0 && !defaultAdded) {
          tmpObj.firstName0 = this.user.firstName
          tmpObj.lastName0 = this.user.lastName
          tmpObj.email0 = this.user.email
          tmpObj.mobile0 = this.user.phone.number
          tmpObj.countryCode0 = this.user.phone.code
          if (this.user.bday) {
            let dob = moment(this.user.bday, 'YYYY-MM-DD')
            tmpObj.birthDay0 = dob.format('DD')
            tmpObj.birthMonth0 = dob.format('MM')
            tmpObj.birthYear0 = dob.format('YYYY')
          }
          if (this.user.address) tmpObj.address0 = this.user.address
          if (this.user.city) tmpObj.city0 = this.user.city
          if (this.user.zip) tmpObj.zip0 = this.user.zip
          if (this.user.country) tmpObj.country0 = this.user.country
          if (this.user.passportNum) tmpObj.passport0 = this.user.passportNum
          defaultAdded = true
        }
        paxForm.adult.push(tmpObj)
      }
      for (let x = 0; x < this.filters.travellers.children; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.children.push(tmpObj)
      }
      for (let x = 0; x < this.filters.travellers.infants; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.infants.push(tmpObj)
      }
      this.$store.commit('booking/clearTravellerInfo')
      this.$store.commit('booking/addTravellerInfo', paxForm)
    },
    reconvertCurrency (x, code) {
      let currRate = this.currencyStore.list[code]
      x = parseFloat(x.toFixed(2))
      x = parseFloat((x / currRate).toFixed(2))
      return x
    },
    nextHighlight () {
      if (!this.pickupText && !this.validation.pickup) this.highlight.active = 'pickup'
      else if ((this.highlight.active === 'pickup' || !this.dropoffText) && !this.validation.dropoff) this.highlight.active = 'dropoff'
      else if (this.highlight.active === 'dropoff') this.highlight.active = 'date'
      else if (this.highlight.active === 'date') this.highlight.active = 'pax'
      else if (this.highlight.active === 'pax') this.highlight.active = 'search'
    },
    continueBooking () {
      this.d2dQueue = ['getFlight']
      this.d2dProcess()
    },
    sendQuoteTime (start, end, quoteId, param) {
      let self = this
      let store = self.$store.state
      let duration = end.diff(start, 'milliseconds') / 1000
      self.$sdk.opt('/quotation/time', {
        token: store.user.token,
        brandId: store.brandId,
        quotationId: quoteId,
        responseTime: duration,
        deviceType: 'ww',
        data: JSON.stringify(param)
      }, res => {
        if (res.error) console.log('ERROR quotation time')
      })
    },
    flightQuoteDone (cabin, leg) {
      let self = this
      let airline = self.airlines[leg]
      let pass = {leg1: false, leg2: false}

      /*
        Check if selected cabin is done loading and not empty
        else check other airlines and change selected
      */

      if (airline.loading.indexOf(airline.selectedCabin) === -1) {
        pass[leg] = airline[airline.selectedCabin].length > 0
        if (!pass[leg]) {
          let cabins = [...self.booking.cabinList]
          let tmpLoading = [...airline.loading]
          let doneCabin = cabins.filter(x => { return tmpLoading.indexOf(x) === -1 })
          let hasChosen = false
          doneCabin.forEach(x => {
            if (!hasChosen && airline[x].length) {
              hasChosen = true
              self.$store.commit('booking/setAirlinesLegData', {
                leg: leg,
                fields: {selectedCabin: x}
              })
              pass[leg] = true
            }
          })
        }
      }

      let otherLeg = leg === 'leg1' ? 'leg2' : 'leg1'
      let airline2 = self.airlines[otherLeg]
      if (self.isReturning && airline2.loading.indexOf(airline2.selectedCabin) === -1) {
        pass[otherLeg] = airline2[airline2.selectedCabin].length > 0
        if (!pass[otherLeg]) {
          let cabins = [...self.booking.cabinList]
          let tmpLoading = [...airline2.loading]
          let doneCabin = cabins.filter(x => { return tmpLoading.indexOf(x) === -1 })
          let hasChosen = false
          doneCabin.forEach(x => {
            if (!hasChosen && airline2[x].length) {
              hasChosen = true
              self.$store.commit('booking/setAirlinesLegData', {
                leg: otherLeg,
                fields: {selectedCabin: x}
              })
              pass[otherLeg] = true
            }
          })
        }
      }

      if (
        (!pass.leg1 || (!pass.leg2 && self.isReturning)) &&
        !airline.loading.length && !airline2.loading.length
      ) {
        let errorTier = Math.max(...[self.flightQuoteError.leg1, self.flightQuoteError.leg2])
        let errorMsg = 'No flights found. Please try again later.'
        if (errorTier === 2) errorMsg = 'Oops! Something went wrong. Please try again later.'
        if (errorTier === 1) errorMsg = 'Something went wrong. Please adjust your search and try again.'
        self.$store.commit('global/setAlertData', {show: true, message: errorMsg})
        self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        return
      }

      if (pass.leg1 && ((self.isReturning && pass.leg2) || !self.isReturning)) {
        document.body.classList.add('widget-full', 'd2d-mode')
        self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        self.$router.push('d2dservice')
      }
    }
  },
  watch: {
    _pickup: function (value) {
      this.pickupText = value
      this.$emit('pickupChange')
    },
    _dropoff: function (value) {
      this.dropoffText = value
      this.$emit('dropoffChange')
    },
    _brandId: function () {
      // this.checkShowOnLoad()
    },
    departureDate (val) {
      this.nextHighlight()
    },
    'filters.travellers.total': function (val) {
      this.nextHighlight()
    }
  },
  mounted () {
    if (this.locations.flight.pickup.title) {
      this.pickup = this.locations.flight.pickup.title
      this.pickupText = this.locations.flight.pickup.title
      this.dropoff = this.locations.flight.dropoff.title
      this.dropoffText = this.locations.flight.dropoff.title
    }
  }
}
</script>

<style lang="scss" scoped>
.field-group{
  &.active{
    outline: 2px solid #ff9c09;
  }
}
.search-field-box{
  gap: 7px;
  margin-bottom: 20px;
  padding: 0;

  .field-group.full-width{
    width: 100%;
    max-width: 390px;
  }
  .field-text{
    margin: 0;
    width: 100%;
    max-width: 160px;
    min-width: 130px;
  }
  .search-submit{
    width: 130px;
    min-width: 130px;
    text-align: center;
    margin-top: 0;

    &.active{
      outline: 2px solid #ff9c09;
    }
  }
}
.reverse-loc{
  border: 1px solid #ccc;
  height: 40px;
  line-height: 40px;
  padding:0 10px;
  background: #fff;
  &:hover{
    background: #f8f8f8;
    cursor: pointer;
  }
}

@media only screen and (max-width: 641px) {
  .search-field-box{
    flex-direction: column;

    .reverse-loc-box{
      position: relative;
      height: 1px;
      width: 100%;
    }
    .reverse-loc{
      position: absolute;
      right: 10px;
      z-index: 2;
      top: -19px;
      border: 1px solid #777;
      background: #f3f2f2;
      transform: rotate(90deg);
    }
    .field-group {
      width: 100%;
      input{
        max-width: 100%;
      }
    }
    .search-submit{
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?f52cd0ba